import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { UserPostInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { createUserInput } from 'src/app/common-components/helpers/user-helper';
import { UserDetailSaveModel } from '../../user-details/models/user-detail-save.model';
import { SaveUser, SaveUserVariables } from '../../user-details/queries/generated/SaveUser';
import { SaveUserMutation } from '../../user-details/queries/save-user.graphql';

@Injectable({ providedIn: 'root' })
export class AddUserApiService {
   constructor(private httpClient: HttpClient, private apiService: LcsApiService) {}

   create(userDetail: UserDetailSaveModel): Observable<ExecutionResult<SaveUser>> {
      const fields: (keyof UserPostInput)[] = [
         'name',
         'emailAddress',
         'username',
         'accountId',
         'extensionId',
         'isSystemUser',
         'isAdmin',
         'isActive',
         'isPasswordMigrated',
      ];
      const user = createUserInput(userDetail, fields);
      const variables: SaveUserVariables = {
         deletedUserRoleIds: [],
         deletedUserReportIds: [],
         deletedUserPrivilegeIds: [],
         deletedUserCallRecordingExtensionIds: [],
         deletedUserCallRecordingExtensionGroupIds: [],
         user: user,
         userPrivileges: [],
      };

      return this.apiService.query<SaveUser, SaveUserVariables>({
         query: SaveUserMutation,
         variables: variables,
      });
   }
}
